import {Component, OnInit, TemplateRef} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DashboardService} from '../dashboard.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ApiService} from '../../core/http/api.service';
import {ToastrService} from 'ngx-toastr';
import {SharedServiceService} from '../../core/services/shared-service.service';

@Component({
    selector: 'app-user-details',
    templateUrl: './user-details.component.html',
    styleUrls: ['./user-details.component.css'],
    standalone: false
})
export class UserDetailsComponent implements OnInit {
  userId: any = '';
  user: any;
  date: string;
  loading = true;
  loaders = Array(10).fill(0);
  modalRef: BsModalRef;
  selectedMembershipId = '';
  membershipData: any[] = [];
  selectedOrganization: any = {};

  // organizations
  organizationPage = 1;
  organizationPerPage = 10;
  organizationTotal: number;
  organizations: any[] = [];
  organizationLoading = true;

  constructor(private route: ActivatedRoute,
              private modalService: BsModalService,
              private dashboardService: DashboardService,
              private shared: SharedServiceService,
              private toastr: ToastrService,
              private api: ApiService
  ) {
  }

  ngOnInit(): void {
    this.shared.subscribeEmitter().subscribe(res => {
      if (res.type === 'organizationPage') {
        this.pageChange(res.data.event);
      }
      if (res.type === 'organizationModal') {
        this.showModal(res.data.event, res.data.type, res.data.data);
      }
      if (res.type === 'organization') {
        this.getAllOrganizations();
      }
      if (res.type === 'closeModal') {
        this.modalRef.hide();
      }
    });
    this.route.params.subscribe(params => this.userId = params['id']);
    this.getUserById();
    this.getAllMemberships();
    this.getAllOrganizations();
  }

  getUserById(): void {
    this.dashboardService.getUserDataById(this.userId).subscribe((data) => {
      this.user = data;
      if (!!data.membership?.id) {
        this.selectedMembershipId = data.membership.id;
      }
      this.date = new Date(this.user.createdAt).toLocaleString();
      this.loading = false;
    }, (err => {
      this.loading = false;
    }));
  }

  getAllOrganizations(): void {
    this.organizationLoading = true;
    this.api.getAllOrganizations({page: this.organizationPage, perPage: 10, user: this.userId}).subscribe((res) => {
      const response = res.response;
      this.organizations = response.organizations || [];
      this.organizationTotal = response.total || 0;
      this.organizationLoading = false;
    }, (err => {
      this.organizationLoading = false;
    }));
  }

  getAllMemberships(): void {
    this.loading = true;
    this.api.getAllMemberships().subscribe((res) => {
      const response = res.response;
      this.membershipData = response.map(val => {
        return {label: val.title, value: val.id};
      });
    });
  }

  showModal(template: TemplateRef<any>, type: any = '', data: any = {}): void {
    if (type === 'organization') {
      this.selectedOrganization = data;
    }

    this.modalRef = this.modalService.show(template, {class: 'modal-dialog-centered'});
  }

  handleSubmit(): void {
    const data = {
      membership_id: this.selectedMembershipId
    };

    this.api.assignMembership(this.userId, data).subscribe(res => {
      this.toastr.success('Membership assigned successfully');
      this.modalRef.hide();
      this.getUserById();
    }, (err => {
      this.toastr.error(err);
    }));

  }

  pageChange(event): void {
    this.organizationPage = event;
    this.getAllOrganizations();
  }

}
